import theme from './movieTheme';
export default {
  ...theme,
  name: 'yellowTheme',

  primary: '#EFC94A',
  secondary: '#334D5C',
  white: '#ECF0F1',
  sub1: '#DF5A49',
};
// 45B29D
